import closeXBtn from "@assets/imgs/btns/close-x-btn.png";
import { AudioManager } from "@/phaser/core/audio/AudioManager";
import { BaseButton } from "@phaser/ui/btns/BaseButton";

export class CloseXBtn extends BaseButton {
  private bg: Phaser.GameObjects.Image;

  static preload(scene: Phaser.Scene) {
    scene.load.image("close-x-btn", closeXBtn);
  }

  constructor(scene: Phaser.Scene, x: number, y: number, onClick: () => void) {
    super(scene, x, y, {
      onClick,
      sfx: () => AudioManager.playSfx("sfx-button"),
    });

    this.bg = scene.add
      .image(0, 0, "close-x-btn")
      .setOrigin(0.5)
      .setScale(0.25);

    this.add(this.bg);

    this.enableButton(this.bg.width * 0.25, this.bg.height * 0.25);

    scene.add.existing(this);
  }
}
